/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/MoveToAnotherTreatment/Events/Content/Event/Appointment/Content/Location/Content"
  
}) {
let appointmentBookingChairResourceOrganizationNameValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'booking.chair.resource.organization.name',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="appointment.booking.chair.resource.organization.name"
 text={appointmentBookingChairResourceOrganizationNameValueData}
 width="auto"
 paddingLeft={dtSpaceXxs}
 justifyContent="flex-start"
 color={dtColorsNeutral700}
/>
{children}
</React.Fragment>)
}